// extracted by mini-css-extract-plugin
export var root = "D_vT";
export var wrapper = "D_vV";
export var image = "D_vW d_w d_y d_W";
export var imageWithHeight = "D_vX";
export var crop = "D_vY";
export var round = "D_vZ";
export var fixedHeight = "D_v0";